import { useContext } from 'react';
import {
  NonCopyableMarkdown,
  NonPastableTextInput,
  SectionWrapper,
} from '../common';
import {
  AssessmentTestContext,
  AssessmentTestContextType,
} from '../../../contexts/assessment-test';
import FollowUp from './FollowUp';

export default function TextInputSection({
  section,
  stepId,
}: {
  section: Extract<
    AssessmentTestContextType['steps'][number]['sections'][number],
    { type: 'text-input' }
  >;
  stepId: string;
}) {
  const [, dispatch] = useContext(AssessmentTestContext);

  const onAnswerChange = (value: string) => {
    dispatch({
      type: 'CHANGE_ANSWER_TEXT_INPUT',
      payload: {
        stepId,
        sectionId: section.id,
        answer: value,
      },
    });
  };

  return (
    <SectionWrapper>
      <NonCopyableMarkdown md={section.content} />
      <NonPastableTextInput
        value={section.answer}
        onChange={onAnswerChange}
        placeholder={section?.placeholder ?? ''}
      />
      <FollowUp section={section} stepId={stepId} />
    </SectionWrapper>
  );
}
